import React, { Component } from 'react';
import { AutoComplete } from 'antd';

class AutoCompleteItem extends Component {
    render() {
        const { style, sinBorde, width, ...rest } = this.props;

        return (
            <AutoComplete 
                {...rest} 
                style={{ width: width || '100%', ...style}} 
            />
        );
    }
}

export default AutoCompleteItem;